// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTenantSecurityConfigurationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantSecurityConfigurationQuery = { __typename?: 'Query', tenantSecurityConfiguration?: { __typename?: 'TenantSecurityConfiguration', id: string, luminaryAccessControlEnabled?: boolean | null, luminarySupportAccess: Types.TenantSecurityConfigurationLuminarySupportAccess, luminarySupportAccessEndDate?: Time | null } | null };

export const Operations = {
  Query: {
    GetTenantSecurityConfiguration: 'GetTenantSecurityConfiguration' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetTenantSecurityConfigurationDocument = gql`
    query GetTenantSecurityConfiguration {
  tenantSecurityConfiguration {
    id
    luminaryAccessControlEnabled
    luminarySupportAccess
    luminarySupportAccessEndDate
  }
}
    `;

/**
 * __useGetTenantSecurityConfigurationQuery__
 *
 * To run a query within a React component, call `useGetTenantSecurityConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantSecurityConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantSecurityConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantSecurityConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantSecurityConfigurationQuery, GetTenantSecurityConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantSecurityConfigurationQuery, GetTenantSecurityConfigurationQueryVariables>(GetTenantSecurityConfigurationDocument, withFetchPolicyContext(options));
      }
export function useGetTenantSecurityConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantSecurityConfigurationQuery, GetTenantSecurityConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantSecurityConfigurationQuery, GetTenantSecurityConfigurationQueryVariables>(GetTenantSecurityConfigurationDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetTenantSecurityConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTenantSecurityConfigurationQuery, GetTenantSecurityConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantSecurityConfigurationQuery, GetTenantSecurityConfigurationQueryVariables>(GetTenantSecurityConfigurationDocument, withFetchPolicyContext(options));
        }
export type GetTenantSecurityConfigurationQueryHookResult = ReturnType<typeof useGetTenantSecurityConfigurationQuery>;
export type GetTenantSecurityConfigurationLazyQueryHookResult = ReturnType<typeof useGetTenantSecurityConfigurationLazyQuery>;
export type GetTenantSecurityConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetTenantSecurityConfigurationSuspenseQuery>;
export type GetTenantSecurityConfigurationQueryResult = Apollo.QueryResult<GetTenantSecurityConfigurationQuery, GetTenantSecurityConfigurationQueryVariables>;